export default function (value, useRaw = false) {
  if (Number.isNaN(value)) {
    return useRaw ? value : '';
  }

  if (!Number.isFinite(value)) {
    return useRaw ? value : '';
  }

  switch (value) {
  case 4:
    return 'Basso';
  case 3:
    return 'Medio';
  case 2:
    return 'Alto';
  case 1:
    return 'Alert';
  default:
    return '';
  }
};
